module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('select', {
    staticClass: "page-lang",
    on: {
      "change": _vm.opchange
    }
  }, [_c('option', {
    attrs: {
      "value": "zh-CN"
    }
  }, [_vm._v("简体中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zh-TW"
    }
  }, [_vm._v("正體中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "en"
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fr"
    }
  }, [_vm._v("Français")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "de"
    }
  }, [_vm._v("Deutsch")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ja"
    }
  }, [_vm._v("日本語 ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pt-BR"
    }
  }, [_vm._v("Português")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ru"
    }
  }, [_vm._v("Русский")])]), _vm._v(" "), _c('section', {
    staticClass: "page-header"
  }, [_c('h1', {
    staticClass: "project-name"
  }, [_vm._v("mavonEditor")]), _vm._v(" "), _c('h3', {
    staticClass: "project-tagline"
  }, [_vm._v(_vm._s(_vm.d_words.sub_title))]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor"
    }
  }, [_vm._v("View on GitHub")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor/archive/refs/heads/master.zip"
    }
  }, [_vm._v("Download .zip")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor/archive/refs/heads/master.tar.gz"
    }
  }, [_vm._v("Download .tar.gz")])]), _vm._v(" "), (!_vm.screen_phone) ? _c('div', {
    staticClass: "item"
  }, [_c('h2', {
    staticClass: "item-header"
  }, [_vm._v("\n            " + _vm._s(_vm.d_words.default_setting) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "item-button"
  }, [_c('button', {
    on: {
      "click": _vm.clearCache
    }
  }, [_vm._v("clear cache")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.uploadimg
    }
  }, [_vm._v("upload")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.imgreplace
    }
  }, [_vm._v("imgreplace")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.imgName),
      expression: "imgName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.imgName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.imgName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.imgdelete
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('div', {
    staticClass: "switch-code-style"
  }, [_c('span', [_vm._v("code style:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.codeStyle),
      expression: "codeStyle"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.codeStyle = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.styles), function(val, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(key))])
  }), 0)])]), _vm._v(" "), _c('mavon-editor', {
    ref: "md",
    staticClass: "item-editor",
    attrs: {
      "subfield": _vm.subfield,
      "toolbarsFlag": _vm.toolbarsFlag,
      "editable": _vm.editable,
      "language": _vm.d_language,
      "ishljs": true,
      "autofocus": _vm.autofocus,
      "shortCut": true,
      "externalLink": _vm.external_link,
      "imageFilter": _vm.image_filter,
      "boxShadow": true,
      "scrollStyle": true,
      "transition": true,
      "codeStyle": _vm.codeStyle,
      "box-shadow-style": "0 2px 12px 0 rgba(0, 0, 0, 0.1)",
      "toolbars-background": "#ffffff",
      "preview-background": "#fbfbfb"
    },
    on: {
      "change": _vm.change,
      "save": _vm.saveone,
      "imgAdd": _vm.$imgAdd,
      "imgDel": _vm.$imgDel,
      "subfieldtoggle": _vm.$subfieldtoggle,
      "previewtoggle": _vm.$previewtoggle
    },
    model: {
      value: (_vm.help1),
      callback: function($$v) {
        _vm.help1 = $$v
      },
      expression: "help1"
    }
  }), _vm._v(" "), _c('button', {
    ref: "diy",
    staticClass: "op-icon fa fa-mavon-align-left",
    attrs: {
      "type": "button",
      "aria-hidden": "true",
      "title": "自定义"
    },
    on: {
      "click": function($event) {
        return _vm.$click('selftest')
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.screen_phone) ? _c('div', {
    staticClass: "item"
  }, [_c('h2', {
    staticClass: "item-header"
  }, [_vm._v("\n            " + _vm._s(_vm.d_words.customize_setting) + "\n        ")]), _vm._v(" "), _c('mavon-editor', {
    staticClass: "item-editor",
    attrs: {
      "language": _vm.d_language,
      "toolbars": _vm.toolbars
    },
    on: {
      "save": _vm.savetwo
    },
    model: {
      value: (_vm.help2),
      callback: function($$v) {
        _vm.help2 = $$v
      },
      expression: "help2"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "margin": "30px 0 15px 0",
      "color": "#1e6bb8"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.d_words.mark) + "\n  ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('h2', {
    staticClass: "item-header"
  }, [_vm._v("\n            " + _vm._s(_vm.d_words.detail)), _c('a', {
    attrs: {
      "href": "https://github.com/hinesboy/mavonEditor"
    }
  }, [_vm._v("GitHub")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-43b244fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43b244fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dev/app.vue
// module id = 215
// module chunks = 0